import { useEffect } from 'react';
import seoConfig from '../../seo/marketingPages.json';

const seoEnv = process.env.REACT_APP_SEO_ENV
  || (process.env.REACT_APP_FIREBASE_PROJECT_ID === 'member-nest-dev' ? 'dev' : 'prod');
const isDevSeo = seoEnv === 'dev';
const siteDomain = String(seoConfig.site?.domain || 'https://member-nest.com').replace(/\/+$/, '');

function canonicalPathForPage(page) {
  return page?.canonicalPath || page?.path || '/';
}

function upsertMeta(selector, attributes) {
  if (typeof document === 'undefined') return;
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement('meta');
    document.head.appendChild(node);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
}

function removeCanonical() {
  if (typeof document === 'undefined') return;
  document.head.querySelectorAll('link[rel="canonical"]').forEach((node) => node.remove());
}

function setCanonical(href) {
  if (typeof document === 'undefined') return;
  let node = document.head.querySelector('link[rel="canonical"]');
  if (!node) {
    node = document.createElement('link');
    node.setAttribute('rel', 'canonical');
    document.head.appendChild(node);
  }
  node.setAttribute('href', href);
}

export default function SeoMeta({ page }) {
  useEffect(() => {
    if (!page) return undefined;
    const canonicalPath = canonicalPathForPage(page);
    const canonicalUrl = `${siteDomain}${canonicalPath === '/' ? '/' : canonicalPath}`;
    document.title = page.title;
    upsertMeta('meta[name="description"]', { name: 'description', content: page.description });
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: page.title });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: page.description });
    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary' });
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: page.title });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: page.description });
    removeCanonical();
    if (isDevSeo) {
      upsertMeta('meta[name="robots"]', { name: 'robots', content: 'noindex,nofollow,noarchive' });
    } else {
      upsertMeta('meta[name="robots"]', { name: 'robots', content: 'index,follow' });
      upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl });
      setCanonical(canonicalUrl);
    }
    return undefined;
  }, [page]);

  return null;
}
